import React, { createContext, useContext, useReducer } from 'react';

const CalculatorContext = createContext();

const initialState = {
  generation: null,
  demand: null,
  total_spendings: null,
  accessTariff: null,
  selectedBattery: null,
  batteryOptions: [],
  results: null,
  loading: false,
  user_data:null,
  contact_data:null,
  error: null
};

function calculatorReducer(state, action) {
  switch (action.type) {
    case 'SET_GENERATION':
      return { ...state, generation: action.payload };
    case 'SET_DEMAND':
      return { ...state, demand: action.payload };
    case 'SET_BATTERY_OPTIONS':
      return { ...state, batteryOptions: action.payload };
    case 'SET_SELECTED_BATTERY':
      return { ...state, selectedBattery: action.payload };
    case 'SET_RESULTS':
      return { ...state, results: action.payload };
    case 'SET_USER_DATA':
      return { ...state, user_data: action.payload };
    case 'SET_LOADING':
      return { ...state, loading: action.payload };
    case 'SET_ERROR':
      return { ...state, error: action.payload };
    case 'SET_TOTAL_SPENDINGS':
      return { ...state, total_spendings: action.payload };
    case 'SET_ACCESS_TARIFF':
      return { ...state, accessTariff: action.payload };
    case 'SET_CONTACT_DATA':
      return {...state,contact_data:action.payload}
    case 'RESET':
      return initialState;
    default:
      return state;
  }
}

export function CalculatorProvider({ children }) {
  const [state, dispatch] = useReducer(calculatorReducer, initialState);

  const setGeneration = (generation) => {
    dispatch({ type: 'SET_GENERATION', payload: generation });
  };

  const setDemand = (demand) => {
    dispatch({ type: 'SET_DEMAND', payload: demand });
  };
  const setUserData=(user_data)=>{
    dispatch({ type: 'SET_USER_DATA', payload: user_data });
  }
  const setContactData=(contact_data)=>{
    dispatch({ type: 'SET_CONTACT_DATA', payload: contact_data });
  }
  const setTotalSpendings=(total_spendings)=>{
    dispatch({ type: 'SET_TOTAL_SPENDINGS', payload: total_spendings });
  };
  const setAccessTariff = (accessTariff) => {
    dispatch({ type: 'SET_ACCESS_TARIFF', payload: accessTariff });
  };
  const setBatteryOptions = (options) => {
    dispatch({ type: 'SET_BATTERY_OPTIONS', payload: options });
  };

  const setSelectedBattery = (battery) => {
    dispatch({ type: 'SET_SELECTED_BATTERY', payload: battery });
  };

  const setResults = (results) => {
    dispatch({ type: 'SET_RESULTS', payload: results });
  };

  const setLoading = (loading) => {
    dispatch({ type: 'SET_LOADING', payload: loading });
  };

  const setError = (error) => {
    dispatch({ type: 'SET_ERROR', payload: error });
  };

  const reset = () => {
    dispatch({ type: 'RESET' });
  };

  const value = {
    ...state,
    setGeneration,
    setDemand,
    setBatteryOptions,
    setUserData,
    setContactData,
    setSelectedBattery,
    setTotalSpendings,
    setAccessTariff,
    setResults,
    setLoading,
    setError,
    reset
  };

  return (
    <CalculatorContext.Provider value={value}>
      {children}
    </CalculatorContext.Provider>
  );
}

export function useCalculator() {
  const context = useContext(CalculatorContext);
  if (!context) {
    throw new Error('useCalculator must be used within a CalculatorProvider');
  }
  return context;
}
